module.exports = require("process");


//////////////////
// WEBPACK FOOTER
// external "process"
// module id = 9
// module chunks = 1